import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authStorage } from '../utils/auth';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';

function DashboardPage() {
  const navigate = useNavigate();
  const token = authStorage.getToken();
  const { config } = useConfig();

  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
    }
  }, [token, navigate]);

  const menuButtons = [
    { label: 'Speakers', href: '/speakers' },
    { label: 'Agenda', href: '/agenda' },
    { label: 'Streaming', href: '/streaming' },
    { label: 'Promociones', href: '/promociones' },
  ];

  if (!token) return null;

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      {/* Fondo */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      {/* Imagen mujer - sobreposición centrada, se superpone al contenido */}
      

      {/* Contenido centrado con sobreposición */}
      <div className="relative z-0 flex flex-col flex-1 items-center justify-between px-4 pt-6">
        <div className="relative z-0 flex flex-col items-center justify-between px-4 pt-6 sm:pt-10">
          <div className="relative w-full overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[180px] sm:min-h-[250px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0 pl-2 sm:pl-4 mr-12 sm:mr-20">
                <img src={config.headerImage} alt="37 Simposio" className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left" />
              </div>
            )}
            {mujerKvUrl && (
              <div className="absolute right-0 bottom-0 h-full w-1/3 sm:w-1/4 flex justify-center items-end pointer-events-none">
                <img src={mujerKvUrl} alt="" className="h-[100%] sm:h-[110%] w-auto object-contain object-bottom mix-blend-screen brightness-110 opacity-50 sm:opacity-60" />
              </div>
            )}
          </div>
        </div>
        {/* Botones - centrados, la imagen mujer se superpone por detrás */}
        <div className="flex-1 flex flex-col items-center justify-center w-full max-w-xs py-4 gap-4">
          {menuButtons.map((btn) => (
            <Link
              key={btn.href}
              to={btn.href}
              className="w-full py-4 px-6 rounded-xl font-semibold text-center text-gray-800 bg-[#a3e635] hover:bg-[#bef264] transition-colors shadow-lg relative z-20"
            >
              {btn.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Logos inferiores */}
      <div className="relative z-20 flex justify-between items-end px-4 py-6 pb-8 gap-4">
        <div className="flex  flex-col  items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img src={logoMedicina} alt="Medicina Biorreguladora de Sistemas" className="h-[110%] w-auto sm:h-20 object-contain object-left max-w-[75%]" />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-8 sm:h-10 object-contain" />
          )}
        </div>
      </div>

    </div>
  );
}

export default DashboardPage;
